import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'datiq-modal-bg',
    templateUrl: './datiq-modal-bg.component.html',
    styleUrls: ['./datiq-modal-bg.component.scss'],
})
export class DatiqModalBgComponent {
    @Input()
    closeOnClick: boolean = false;
    @Input()
    closeOnEsc: boolean = false;
    @Output()
    closed: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    clickBg(): void {
        !!this.closeOnClick ? this.closed.emit() : null;
    }

    pressEscape(): void {
        !!this.closeOnEsc ? this.closed.emit() : null;
    }
}
